export default "__VITE_ASSET__I7$CcLqw__"